module.exports = __webpack_public_path__ + "img/illu_templates.f51e7396.svg";